import { TOOLS } from '../../data/siteData';

export const ToolMarquee = () => (
  <div className="tools" aria-label={`Software we work in: ${TOOLS.join(', ')}`}>
    <div className="track" aria-hidden="true">
      {[...TOOLS, ...TOOLS].map((tool, i) => (
        <span key={`${tool}-${i}`}>{tool}</span>
      ))}
    </div>
  </div>
);

export default ToolMarquee;
